import {
  Avatar,
  Box,
  Button,
  InputBase,
  makeStyles,
  Theme,
} from '@material-ui/core';
import React, { forwardRef, useImperativeHandle, useState } from 'react';

interface IProps {
  onSubmit: (content: string) => void;
  submitting: boolean;
  avatar: string;
}
export interface IHandler {
  clear: () => void;
}
const inputLimit = 5000;
const useStyles = makeStyles((theme: Theme) => ({
  submitButton: {
    borderRadius: theme.spacing(2),
    color: 'white',
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  textfield: {
    backgroundColor: 'white',
    borderRadius: 4,
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    margin: `${theme.spacing(1)}px 0px`,
    maxWidth: 400,
  },
}));
const CommentationForm: React.ForwardRefRenderFunction<IHandler, IProps> = (
  { avatar, onSubmit, submitting },
  ref
) => {
  const { submitButton, textfield } = useStyles();
  const [content, setContent] = useState('');
  useImperativeHandle(ref, () => ({
    clear: () => {
      setContent('');
    },
  }));

  const handleSubmit = () => {
    onSubmit(content);
  };
  const handleTextFieldChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    event.persist();
    setContent(event.target.value);
  };
  return (
    <Box p={2} display='flex'>
      <Box mr={2}>
        <Avatar src={avatar} />
      </Box>
      <Box width='100%' display='flex' flexDirection='column'>
        <InputBase
          className={textfield}
          multiline
          rows={4}
          fullWidth
          value={content}
          onChange={handleTextFieldChange}
          disabled={submitting}
          placeholder='พิมพ์ข้อความตอบกลับที่นี่'
          inputProps={{ maxLength: inputLimit }}
        />
        <Box mt={2} mb={1}>
          <Button
            className={submitButton}
            variant='contained'
            color='secondary'
            onClick={handleSubmit}
            disabled={content === '' || submitting}
          >
            ส่ง
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default forwardRef(CommentationForm);
